import React, { useEffect, useState } from "react";
import Footer from "../components/Shared/Footer";
import { useNavigate } from "react-router-dom";
import Modal from "../components/Shared/Modal";
import axios from "axios";

const PaymentSuccess = () => {
return(
    <div>
        <p>Payment Success!</p>
    </div>
)
}

export default PaymentSuccess;
